<template lang="pug">
  .main
    v-layout(style="height:100vh")
      v-container.my-auto(style="max-width: 500px;" :class="{'mx-0 px-0': this.$vuetify.breakpoint.xs}")
        v-card.mt-4.px-2.py-4(flat :tile="this.$vuetify.breakpoint.xs" :class="{'px-8': !this.$vuetify.breakpoint.xs}")
          v-card-text(:class="{'pb-0': this.$vuetify.breakpoint.xs}")
            template(v-if="timeout")
              div.text-center
                eva-icon.mb-n1(name="close-circle-outline" width="48" height="48" :fill="$vuetify.theme.themes[$theme].danger500")
                .h5 Link Expired
                .p1.mt-4.mx-4 You can close this page or log in again
            template(v-else-if="loading")
              div.text-center
                .p1.mx-4 Approving sign in...
            template(v-else)
              template(v-if="success")
                div.text-center
                  eva-icon.mb-n1(name="checkmark-circle-2-outline" width="48" height="48" :fill="$vuetify.theme.themes[$theme].infoT48")
                  .h5 Log in approved
                  .p1.mt-4.mx-4 You can close this page and return to
                  .p1.mb-1.mx-4  your previous log in page or
                  .s1(@click="continueSignIn")  continue log in here.
              template(v-else)
                div.text-center
                  eva-icon.mb-n1(name="close-circle-outline" width="48" height="48" :fill="$vuetify.theme.themes[$theme].danger500")
                  .h5 Log in Not Approved
                  .p1.mt-4.mx-4 This link is already expired. Please request to sign in again.
</template>

<script>
import Cookies from 'js-cookie'
import TopBar from '@/components/TopBar.vue'

export default {
  name: 'ApproveSignIn',
  components: { TopBar },
  props: ['token'],
  data: () => ({
    loading: true,
    success: false,
    userData: null,
    timer: 300,
    timeout: false
  }),
  mounted () {
    const interval = setInterval(() => {
      this.timer--
      if (this.timer <= 0) {
        this.userData = null
        this.timeout = true
        clearInterval(interval)
      }
    }, 1000)
    this.$axios.post('/users/authorize_auth_link/', { token: this.token })
    .then(resp => {
      this.success = true
      this.userData = resp.data
    })
    .catch(() => {})
    .finally(() => {
      this.loading = false
    })
  },
  methods: {
    continueSignIn () {
      this.$store.commit('user/setUser', this.userData)
      this.$axios.defaults.headers.common['Authorization'] = `Token ${this.userData.token}`
      if (this.$isLandingPage || !this.$subdomain) {
        this.$router.push('/companies')
      } else {
        let cookieNextPath = Cookies.get('yz_next_path')
        if (cookieNextPath) {
          this.$router.push(cookieNextPath)
          this.$store.commit('ui/setRedirectPath', null)
        } else {
          this.$router.push('/admin/dashboard')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>